import { sbEditable } from '@storyblok/storyblok-editable'
import * as React from 'react'
import { ButtonModule } from "../Button";
import styled from 'styled-components'
import { TitleWithPrefix } from '../../components/UI/TitleWithPrefix'
import { containerDefault } from '../../lib/styles/Container'
import { Columns } from './Columns'
import { HeroBannerProps } from './types';

const ModuleWrapper = styled.div`
  padding: 20px;
  border-radius: 20px;
  width: 90vw;
  max-width: 80vw;
  margin: 0rem auto;

  @media screen and (max-width: 768px) {
    padding: 0;
  }
  `

export const HeroBannerModule = ({ blok }: HeroBannerProps) => {
  const { isSlider, buttons, noBorder } = blok

  const headlineSize = blok.headlineSize ? blok.headlineSize : 'small'
  const blokAlignment = blok.alignment ? blok.alignment : 'left'

  // const mediumCenterMargin = headlineSize === 'medium' && blokAlignment === 'center' ? '3rem' : ''
  // const smallCenterMargin = headlineSize === 'small' && blokAlignment === 'center' ? '2.5rem' : ''
  // const mediumLeftMargin = headlineSize === 'medium' && blokAlignment === 'left' ? '1.5rem' : ''
  // const smallLeftMargin = headlineSize === 'small' && blokAlignment === 'left' ? '1rem' : ''

  return (
    <ModuleWrapper {...sbEditable(blok)}>
      <Columns blok={blok} $align={blok.alignment} $width={blok.width} />
    </ModuleWrapper>
  )
}
